import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO/SEO';
import { ServiceSchema, BreadcrumbSchema } from '../components/SEO/StructuredData';
import ServicePage from '../components/ServicePage/ServicePage';

// Import Software After Sales images - using IT images as placeholders
import afterSalesImage1 from '../assets/images/services/maintenance/CCTV AND ACCESS CONTROL MAINTENANCE.jpg';
import afterSalesImage2 from '../assets/images/services/it/EMS.jpg';
import afterSalesImage3 from '../assets/images/services/maintenance/Ac .jpg';
import afterSalesImage4 from '../assets/images/services/it/STRUCTURED CABLING AND NETWORKING.jpg';

// Import video specific to this service
import afterSalesVideo from '../assets/videos/software/ui-ux.mp4';

// Import benefits image
import afterSalesBenefitsImage from '../assets/images/software/after-sales.jpg';

const SoftwareAfterSalesPage: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <SEO title="After Sales Support" description="Software after-sales support and maintenance in DRC. Ongoing technical support, updates, and system maintenance by Cool & Care." keywords="after sales support DRC, software maintenance, technical support, system updates Kinshasa" />
      <ServiceSchema name="After Sales Support" description="Software after-sales support, maintenance, and ongoing technical assistance." url="/software-after-sales" />
      <BreadcrumbSchema items={[{ name: 'Software', url: '/software' }, { name: 'After Sales', url: '/software-after-sales' }]} />
      <ServicePage
        serviceName={t('servicePage.services.softwareAfterSales.name')}
      serviceDescription={t('servicePage.services.softwareAfterSales.description')}
      videoUrl={afterSalesVideo}
      productImages={[
        afterSalesImage1,
        afterSalesImage2,
        afterSalesImage3,
        afterSalesImage4
      ]}
      features={t('servicePage.services.softwareAfterSales.features', { returnObjects: true }) as string[]}
      benefits={t('servicePage.services.softwareAfterSales.benefits', { returnObjects: true }) as string[]}
      benefitsImage={afterSalesBenefitsImage}
    />
    </>
  );
};

export default SoftwareAfterSalesPage;

